import { render } from "./MemberMyProfile.vue?vue&type=template&id=039f077c"
import script from "./MemberMyProfile.vue?vue&type=script&lang=js"
export * from "./MemberMyProfile.vue?vue&type=script&lang=js"

import "./MemberMyProfile.vue?vue&type=style&index=0&id=039f077c&lang=css"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__